export const INDEX = '/index.html'
export const OVERVIEW = '/'
export const LOGIN = '/login'
export const VERIFICATION = '/verification'
export const LOGOUT = '/logout'
export const GROUPS = '/groups'
export const GROUP = '/groups/:group_id'
export const SETTINGS = '/settings'
export const SETTINGS_EDIT_MAMORIO = '/settings/mamorio'
export const SETTINGS_GROUP_MANAGEMENT = '/settings/group-management'
export const SETTINGS_GROUP_MANAGEMENT_USERS = '/settings/group-management/:group_id'
export const SETTINGS_MAMORIO_SPOT = '/settings/mamorio-spot'
export const SETTINGS_EVENT_TRIGGERS = '/settings/event-triggers'
export const SETTINGS_QR_TAGS = '/settings/qr-tags'
export const SETTINGS_RFID = '/settings/rfid'
export const SETTINGS_BIZ_ACCESS_LOGS = '/settings/biz-access-logs'
export const SETTINGS_BIZ_ACCESS_LOGS_DETAIL = '/settings/biz-access-logs/:logId'
export const USER_SETTING = '/users/:user_id/setting'
export const SPOTS = '/spots'
export const NEWS = '/news'
export const UNAUTHORIZED = '/unauthorized'
export const HEATMAP = '/heatmap'
export const BIZ_PLUS_TEST = '/biz_plus_test'
export const BIZ_PLUS_AKITA = '/biz_plus_akita'
export const MAMORIOS_DETAIL = '/mamorios/:major_minor'
export const MAMORIOS_EDIT = '/mamorios/:major_minor/edit'
export const GPS_TRACKERS_DETAIL = '/gps_trackers/:device_token'
export const QR_TAG_EVENT_RECORDER = '/groups/:group_id/qr-tags/events'
export const GROUP_QR_PRINT = '/groups/:group_id/qr-tags/print-group'
export const DASHBOARD_DEMO = '/dashboard_demo'
// 管理者専用の隠し画面。ナビゲーションからは辿れない。
export const SAML_SETUP = '/saml-setup'
